/**
 * 對話頁嘅提示列（UI v2 步 5：由 `ChatPage.tsx` **純搬**出嚟，零行為改動）
 *
 *   · `ChatHints`       → 標記模式提示／聊天模式提示／處理緊／出歌中／操作錯誤／温柔提示／流程錯誤
 *   · `ContinuePrompt`  → **歌完成後**：〔繼續傾〕切換 ＋「下一個訊息會開新對話」提示
 */
import type { TFunction } from 'i18next';

export interface ChatHintsProps {
  t: TFunction;
  pickHintVisible: boolean;
  mode: string;
  busyAction: boolean;
  renderingId: string | null;
  actionError: string | null;
  gentle: string | null;
  flowError: string | null;
  flowPhase: string;
}

export function ChatHints({ t, pickHintVisible, mode, busyAction, renderingId, actionError, gentle, flowError, flowPhase }: ChatHintsProps) {
  return (
    <>
      {pickHintVisible ? (
        <p className="page__hint" role="status" data-testid="pick-hint">
          {t('pick_hint')}
        </p>
      ) : null}
      {/* ⭐ `decisions/027`：聊天模式提示（模式只改語氣；一樣會準確接收情緒 → 照樣寫得出好歌） */}
      {mode === 'chat' ? (
        <p className="page__hint" role="status" data-testid="mode-hint">
          {t('chat_mode_hint')}
        </p>
      ) : null}
      {busyAction ? (
        <p className="page__hint" role="status" data-testid="working-hint">
          {t('working_hint')}
        </p>
      ) : null}
      {renderingId ? (
        <p className="page__hint" role="status">
          {t('song_render_pending')}
        </p>
      ) : null}
      {actionError ? (
        <p className="page__error" role="alert">
          {actionError}
        </p>
      ) : null}
      {gentle ? (
        <p className="page__hint" role="status">
          {gentle}
        </p>
      ) : null}
      {flowError && flowPhase !== 'lyrics' ? (
        <p className="page__error" role="alert">
          {flowError}
        </p>
      ) : null}
    </>
  );
}

export interface ContinuePromptProps {
  t: TFunction;
  keepGoing: boolean;
  onToggleKeepGoing: () => void;
  langBtn: (active: boolean) => string;
}

/** 歌完成後：〔繼續傾〕（唔撳＝下一個訊息開新對話） */
export function ContinuePrompt({ t, keepGoing, onToggleKeepGoing, langBtn }: ContinuePromptProps) {
  return (
    <div style={{ display: 'flex', gap: '8px', alignItems: 'center', padding: '0 12px 4px', flexWrap: 'wrap' }}>
      <button type="button" className={langBtn(keepGoing)} aria-pressed={keepGoing} onClick={onToggleKeepGoing}>
        {t('keep_going_toggle')}
      </button>
      <span className="footnote">{keepGoing ? '' : t('new_chat_will_start')}</span>
    </div>
  );
}
